define('controls/range',["exports", "bootstrap/slider"], function (_exports, _slider2) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _slider2 = _interopRequireDefault(_slider2);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
  function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
  function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
  function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
  function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
  function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
  var _value = new WeakMap();
  var _from = new WeakMap();
  var _to = new WeakMap();
  var _model = new WeakMap();
  var _startProp = new WeakMap();
  var _startFmt = new WeakMap();
  var _endProp = new WeakMap();
  var _endFmt = new WeakMap();
  var _slider = new WeakMap();
  class Range {
    constructor(el, {
      model,
      start,
      startProp,
      startFmt = String,
      end,
      endProp,
      endFmt = String,
      max,
      maxProp,
      min,
      minProp,
      step,
      stepProp,
      delayProp,
      dependencyProps,
      tooltip = 'hide'
    } = {}) {
      _classPrivateFieldInitSpec(this, _value, void 0);
      _classPrivateFieldInitSpec(this, _from, void 0);
      _classPrivateFieldInitSpec(this, _to, void 0);
      _classPrivateFieldInitSpec(this, _model, void 0);
      _classPrivateFieldInitSpec(this, _startProp, void 0);
      _classPrivateFieldInitSpec(this, _startFmt, void 0);
      _classPrivateFieldInitSpec(this, _endProp, void 0);
      _classPrivateFieldInitSpec(this, _endFmt, void 0);
      _classPrivateFieldInitSpec(this, _slider, void 0);
      var input = el.querySelector('[data-range=input]');
      _classPrivateFieldSet(_from, this, el.querySelector('[data-range=from]'));
      _classPrivateFieldSet(_to, this, el.querySelector('[data-range=to]'));
      _classPrivateFieldSet(_model, this, model);
      _classPrivateFieldSet(_startProp, this, startProp);
      _classPrivateFieldSet(_endProp, this, endProp);
      _classPrivateFieldSet(_startFmt, this, startFmt);
      _classPrivateFieldSet(_endFmt, this, endFmt);
      _classPrivateFieldSet(_slider, this, new _slider2.default(input, {
        min: Number(model && minProp && model.get(minProp) || min || el.dataset.rangeMin) || 0,
        max: Number(model && maxProp && model.get(maxProp) || max || el.dataset.rangeMax) || 100,
        step: Number(model && stepProp && model.get(stepProp) || step || el.dataset.rangeStep) || 1,
        tooltip,
        value: [Number(model && startProp && model.get(startProp) || start || el.dataset.rangeStart) || 0, Number(model && endProp && model.get(endProp) || end || el.dataset.rangeEnd) || 100]
      }));
      if (model) {
        var event = '';
        if (startProp) {
          event += `change:${startProp} `;
        }
        if (endProp) {
          event += `change:${endProp} `;
        }
        if (dependencyProps) {
          dependencyProps.forEach(prop => {
            event += `change:${prop} `;
          });
        }
        if (event) {
          model.on(event, m => {
            _classPrivateFieldSet(_value, this, [m.get(startProp), m.get(endProp)]);
            this._updateLabels();
          });
        }
        event = '';
        if (maxProp) {
          event += `change:${maxProp} `;
        }
        if (minProp) {
          event += `change:${minProp} `;
        }
        if (startProp) {
          event += `change:${startProp} `;
        }
        if (endProp) {
          event += `change:${endProp} `;
        }
        if (stepProp) {
          event += `change:${stepProp} `;
        }
        if (event) {
          model.on(event, m => {
            if (minProp) {
              _classPrivateFieldGet(_slider, this).setAttribute('min', m.get(minProp));
            }
            if (maxProp) {
              _classPrivateFieldGet(_slider, this).setAttribute('max', m.get(maxProp));
            }
            if (stepProp) {
              _classPrivateFieldGet(_slider, this).setAttribute('step', m.get(stepProp));
            }
            if (endProp) {
              _classPrivateFieldGet(_slider, this).setValue([m.get(startProp), m.get(endProp)]);
            }
          });
        }
      }
      input.addEventListener('slide', () => {
        var value = _classPrivateFieldGet(_slider, this).getValue();
        if (Number.isFinite(value[0]) && Number.isFinite(value[1])) {
          _classPrivateFieldSet(_value, this, value);
          if (model) {
            if (startProp && model.get(startProp) !== value[0] || endProp || model.get(endProp) !== value[1]) {
              var ch = {};
              if (delayProp) {
                ch[delayProp] = true;
              }
              if (startProp) {
                ch[startProp] = value[0];
              }
              if (endProp) {
                ch[endProp] = value[1];
              }
              model.set(ch);
            }
          } else {
            this._updateLabels();
          }
        }
      }, {
        passive: true
      });
      input.addEventListener('slideStop', () => {
        var value = _classPrivateFieldGet(_slider, this).getValue();
        if (Number.isFinite(value[0]) && Number.isFinite(value[1])) {
          _classPrivateFieldSet(_value, this, value);
          if (model) {
            var ch = {};
            if (delayProp) {
              ch[delayProp] = false;
            }
            if (startProp) {
              ch[startProp] = value[0];
            }
            if (endProp) {
              ch[endProp] = value[1];
            }
            model.set(ch);
          } else {
            this._updateLabels();
          }
        }
      }, {
        passive: true
      });
    }
    get start() {
      return _classPrivateFieldGet(_model, this) && _classPrivateFieldGet(_startProp, this) && _classPrivateFieldGet(_model, this).get(_classPrivateFieldGet(_startProp, this)) || _classPrivateFieldGet(_value, this)[0];
    }
    get end() {
      return _classPrivateFieldGet(_model, this) && _classPrivateFieldGet(_endProp, this) && _classPrivateFieldGet(_model, this).get(_classPrivateFieldGet(_endProp, this)) || _classPrivateFieldGet(_value, this)[1];
    }
    destroy() {
      _classPrivateFieldGet(_slider, this).destroy();
    }
    _updateLabels() {
      _classPrivateFieldGet(_from, this).innerHTML = _classPrivateFieldGet(_startFmt, this).call(this, this.start);
      _classPrivateFieldGet(_to, this).innerHTML = _classPrivateFieldGet(_endFmt, this).call(this, this.end);
    }
  }
  _exports.default = Range;
});//# sourceMappingURL=range.js.map
;
